import { getRequest } from '../../httpClient';
import type { IListFeaturedChallengesV1Response } from './list-featured-challenges-v1-response';
import { listFeaturedChallengesV1ResponseSchema } from './list-featured-challenges-v1-response';

interface IListFeaturedChallengesV1Options {
  limit?: number;
}

export async function listFeaturedChallengesV1Api(options?: IListFeaturedChallengesV1Options) {
  const params: Record<string, number> = {};
  if (options?.limit) {
    params.limit = options.limit;
  }
  return getRequest<IListFeaturedChallengesV1Response>({
    path: '/challenges/v1/featured',
    options: Object.keys(params).length > 0 ? { params } : undefined,
    schema: listFeaturedChallengesV1ResponseSchema,
  });
}
